import { provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { routes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAuth, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';
import { CommonHttpInterceptor } from 'projects/shared/src/lib/infrastructure/interceptors/common-http.interceptor';
import { openIdConfigurationFactory } from 'projects/shared/src/lib/infrastructure/auth/auth-config';
import { Environment } from 'projects/shared/src/lib/core/interfaces/environment';
import { ENVIRONMENT_TOKEN } from 'projects/shared/src/lib/core/injection-tokens/environment.token';
import { providePrimeNG } from 'primeng/config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { RekensprintPreset } from '../assets/rekensprint-theme';
import { EXERCISE_FLOW_ADAPTER_TOKEN } from 'projects/shared/src/lib/core/injection-tokens/exercise-flow-adapter.token';
import { ProgramFlowAdapter } from './infrastructure/adapters/program-flow.adapter';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export const appConfig = (environment: Environment) => ({
  providers: [
    ProgramFlowAdapter,
    { provide: ENVIRONMENT_TOKEN, useValue: environment },
    { provide: EXERCISE_FLOW_ADAPTER_TOKEN, useExisting: ProgramFlowAdapter },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CommonHttpInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, withViewTransitions()),
    provideZonelessChangeDetection(),
    provideAuth(
      {
        config: openIdConfigurationFactory(environment),
      },
      withAppInitializerAuthCheck()
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        failOnError: true,
        resources: [
          { prefix: 'assets/i18n/', suffix: '.json' },
          { prefix: 'assets/i18n/tasks-content/', suffix: '.json' },
        ],
      }),
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: { preset: RekensprintPreset, options: { darkModeSelector: '.app-dark' } },
    }),
  ],
});
